var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientClassificationFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 11H12C10.9 11 10 11.9 10 13V27C10 28.1 10.9 29 12 29H28C29.1 29 30 28.1 30 27V13C30 11.9 29.1 11 28 11ZM17 25H14C13.45 25 13 24.55 13 24C13 23.45 13.45 23 14 23H17C17.55 23 18 23.45 18 24C18 24.55 17.55 25 17 25ZM17 21H14C13.45 21 13 20.55 13 20C13 19.45 13.45 19 14 19H17C17.55 19 18 19.45 18 20C18 20.55 17.55 21 17 21ZM17 17H14C13.45 17 13 16.55 13 16C13 15.45 13.45 15 14 15H17C17.55 15 18 15.45 18 16C18 16.55 17.55 17 17 17ZM26.7 19.12L23.53 22.29C23.14 22.68 22.5 22.68 22.11 22.29L20.7 20.87C20.31 20.48 20.31 19.85 20.7 19.46C21.09 19.07 21.72 19.07 22.11 19.46L22.82 20.17L25.29 17.7C25.68 17.31 26.31 17.31 26.7 17.7L26.71 17.71C27.09 18.1 27.09 18.74 26.7 19.12Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientClassificationFilledIcon);
export default __webpack_public_path__ + "static/media/client_classification_filled_icon.722458cf13b7145a067cf2f4ab70d60a.svg";
export { ForwardRef as ReactComponent };